import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import {
  PagePaginationResponseDtoSchema,
  responseContract,
  type PagePaginationRequestDto,
} from '../../lib';
import { ResidentNotesDtoSchema } from '../contracts';

export const GetResidentNoteResponseDtoSchema = PagePaginationResponseDtoSchema(
  ResidentNotesDtoSchema
);

export type GetResidentNoteRequestDto = PagePaginationRequestDto<
  { id: number },
  'creationDate' | 'takenBy'
>;
export type GetResidentNoteResponseDto = z.infer<
  typeof GetResidentNoteResponseDtoSchema
>;

export const getResidentNotes = (
  params: GetResidentNoteRequestDto,
  config?: AxiosRequestConfig<GetResidentNoteRequestDto>
) => {
  const { id, ...restParams } = params;

  return api
    .get(`residents/${id}/notes`, { params: restParams, ...config })
    .then(responseContract(GetResidentNoteResponseDtoSchema));
};
